export function throttle(fn, delay) {
  let lastExecutionTime = 0;
  return function(...args) {
    const now = Date.now();
    if (now - lastExecutionTime >= delay) {
      lastExecutionTime = now;
      fn.apply(this, args);
    }
  };
}

export function getProjectCode(contract, project) {
	if(contract?.parent_contract || contract?.subcontract_parent || contract?.addendum_parent){
		let append = ''
		if(contract.addendum_to_contract_id){
			append = ` - ANX Nº ${contract.addendum_index}`
		}
		else if(contract.subcontract_to_contract_id){
			append = ` - SUB Nº ${contract.subcontract_index}`
		}
		const contract_prefix_index = contract.parent_contract?.info?.contract_prefix_index || contract.subcontract_parent?.info?.contract_prefix_index || contract.addendum_parent?.info?.contract_prefix_index || contract.info?.contract_prefix_index
		return `${contract.serial?.serial} - LP${project?.project_line_info?.project_line?.number} - ${contract.info?.prefix?.prefix} ${contract_prefix_index} ${append}`
	}
	return `${contract.serial?.serial} - LP${project?.project_line_info?.project_line?.number} - ${contract.info?.prefix?.prefix} ${contract.info?.contract_prefix_index}`
}